import request from "@/utils/request";

// 查用户核算公司
export function getUserPayCompany(params) {
    return request({
        url: '/hrm/payCompany/getUserPayCompany',
        method: 'get',
        params
    })
}